import { render, staticRenderFns } from "./ServiceBots.vue?vue&type=template&id=d2f8f0e8"
import script from "./ServiceBots.vue?vue&type=script&lang=js"
export * from "./ServiceBots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports